import { service } from 'Services/api/api.service';
import { ReferralServiceType } from './types';

const BASE_ENDPOINT_URL = 'referral';

const ReferralService: ReferralServiceType = {
  getLinks: () => service.get(`${BASE_ENDPOINT_URL}`),
  patchUserClabe: params => service.patch(`${BASE_ENDPOINT_URL}`, params),
  getProfits: () => service.get(`${BASE_ENDPOINT_URL}/profits`),
  getReferralLinks: () => service.get(`${BASE_ENDPOINT_URL}/couponLinks`),
};

export default ReferralService;
